import React from 'react';

const Text = ({ title, subtitle }) => {
  return (
    <div
      className="absolute z-30 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                 text-center p-8"
    >
      {/* Naslov sa svetlećim efektom */}
      <h1 className="text-5xl font-bold text-white mb-4 animate-glow">
        {title}
      </h1>
      
      {/* Podnaslov koji se pojavljuje nakon naslova */}
      <p className="text-xl text-gray-400 animate-subtleFade" style={{ animationDelay: '5s' }}>
        {subtitle}
      </p>
    </div>
  );
};

export default Text;
